import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild, inject, DestroyRef} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { PaginatorComponent } from 'src/app/components/paginator/paginator.component';
import { Configuration } from 'src/app/models/configurations/configuration';
import { Constants } from 'src/app/models/constants';
import { KeyValueMap } from 'src/app/models/key-value-map';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { ConfigurationDetailsComponent } from '../configuration-details/configuration-details.component';
import { MatDialog } from '@angular/material/dialog';
import { ConfigurationApplicationStatus } from 'src/app/models/configurations/configuration-state';
import { Instance } from 'src/app/models/instance/instance';
import { DeployStatus } from 'src/app/models/deploy/deploy-status';
import { Permission } from 'src/app/models/principal/permission';
import { PermissionsService } from 'src/app/services/util/permissions.service';
import { DeploymentClass } from 'src/app/models/instance-class';
import { DataZone } from 'src/app/models/data-zone/data-zone';
import { Attributes, Datazone } from 'src/app/models/principal/permission';
import { PermissionKeys } from 'src/app/models/principal/permission-keys';
import { Permissions } from 'src/app/models/principal/permission';

const REQUIRED_PERMISSIONS = [
  {
    key: PermissionKeys.INSTANCE_TEST_DATAZONE_NONPII,
    action: Permissions.INSTANCE_TEST,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.NONPII
  },
  {
    key: PermissionKeys.INSTANCE_TEST_DATAZONE_PII,
    action: Permissions.INSTANCE_TEST,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.INSTANCE_TEST_DATAZONE_LIVE,
    action: Permissions.INSTANCE_TEST,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  },
];

@Component({
    selector: 'app-instance-execute-rvt',
    templateUrl: './instance-execute-rvt.component.html',
    styleUrls: ['./instance-execute-rvt.component.scss'],
    standalone: false
})
export class InstanceExecuteRvtComponent implements OnInit {
  @ViewChild(PaginatorComponent, { static: true }) paginator: PaginatorComponent;

  @Output() executeRvtClick = new EventEmitter();

  @Input() instance: Instance;

  @Input() configs: any[];

  ConfigurationApplicationStatus = ConfigurationApplicationStatus;

  configurations: any[];
  pageConfigurations: Configuration[];
  filteredConfigurations: Configuration[];
  expandedRows: KeyValueMap<string, boolean> = {};

  selection: Configuration;
  Constants = Constants;
  deploymentClass = DeploymentClass;
  Permission = Permission;

  inProgress = false;
  searchValue: string;
  selectedId: any;
  disableSelect = false;
  permissionsMap: { [key: string]: boolean };
  DataZone = DataZone;
  DeployStatus = DeployStatus;
  PermissionKeys = PermissionKeys;
  private destroyRef = inject(DestroyRef);

  constructor(public sidenavService: SidenavService, public datepipe: DatePipe, private changeDetectorRef: ChangeDetectorRef,
    private matDialog: MatDialog, private permissionsService: PermissionsService) {
  }

  @Input() set executeRvtInProgressing(applyConfigInProgress) {
    this.inProgress = applyConfigInProgress;
  };

  @Input() set availableConfigurationsForRvt(availableConfigurations: Configuration[]) {
    this.configurations = availableConfigurations !== undefined ? [...availableConfigurations] : [];
    const selected = this.configurations?.find(item => item?.id === this.selectedId);
    this.paginator.pageIndex = 0;
    this.configurations.sort(this.defaultComparator);
    if(selected) {
    this.configurations = this.configurations?.filter(item => item?.id !== this.selectedId);
    this.configurations = [selected, ...this.configurations];
    this.setFlagValues(selected);
  }
    this.search(this.searchValue);
  }

  ngOnInit(): void {
    this.permissionsMap = this.permissionsService.resolveAPIPermissions(REQUIRED_PERMISSIONS);
    const selected = this.configurations?.find(config => config?.id === this.instance?.latestRvtState?.configurationId
      && config?.status === ConfigurationApplicationStatus.TESTING);
    if (selected) {
      this.selectedId = selected?.id;
      this.selection = selected;
      this.configurations = this.configurations?.filter(item => item?.id !== this.selectedId);
      this.configurations = [selected, ...this.configurations];
      this.setFlagValues(this.selection);
    }
    if (this.instance?.status !== DeployStatus.TESTED && this.instance?.status !== DeployStatus.CONFIGURED &&
      this.instance?.status !== DeployStatus.DEPLOYED  && this.instance?.status !== DeployStatus.CONFIGURATION_FAILED &&
      this.instance?.status !== DeployStatus.TEST_FAILED && this.instance?.status !== DeployStatus.UPDATED) {
        this.disableSelect = true;
      }
    this.paginator.page
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(pageEvent => {
      const startIndex = pageEvent.pageIndex * pageEvent.pageSize;
      this.pageConfigurations = this.filteredConfigurations.slice(startIndex, startIndex + pageEvent.pageSize);
      if (!this.pageConfigurations.includes(this.selection)) {
      }
      this.changeDetectorRef.detectChanges();
    });
    this.search();
  }

  setFlagValues(selected): void {
    if (selected?.status === ConfigurationApplicationStatus.CONFIGURING ||
      selected?.status === ConfigurationApplicationStatus.CONFIGURED ||
      selected?.status === ConfigurationApplicationStatus.TESTING || selected?.status === ConfigurationApplicationStatus.VERIFYING ||
      (this.instance?.status !== DeployStatus.TESTED && this.instance?.status !== DeployStatus.CONFIGURED &&
      this.instance?.status !== DeployStatus.DEPLOYED && this.instance?.status !== DeployStatus.CONFIGURATION_FAILED &&
      this.instance?.status !== DeployStatus.TEST_FAILED && this.instance?.status !== DeployStatus.UPDATED)) {
        this.disableSelect = true;
    } else if (selected?.status === ConfigurationApplicationStatus.TEST_FAILED ||
        selected?.status === ConfigurationApplicationStatus.SUCCESS) {
      this.disableSelect = false;
    };
  }

  expandRow(configuration: Configuration): void {
     this.expandedRows[configuration.id] = !this.expandedRows[configuration.id];
  }

  configurationNameClick(configuration: any): void {
    configuration.instanceName = this.instance.name;
    const isRvt = true;
    this.matDialog.open(ConfigurationDetailsComponent, {
      height: '50vh',
      width: '40vw',
      panelClass: 'flex-dialog',
      data: {
        configuration,
        isRvt
      }
    });
  }

  /**
   * Performs a simple search in the list of configurations
   *
   * @param value Method that filters displayed configurations based on search criteria.
   */
  search(value?: string): void {
    if(value) {
      this.searchValue = value.toLowerCase();
      this.filteredConfigurations = this.configurations.filter(config =>
        config.manifest.name.toLowerCase().includes(this.searchValue) ||
        config.manifest.version.toLowerCase().includes(this.searchValue));
    } else {
      this.filteredConfigurations = this.configurations;
    }

    // Clear selection when page is changed
    if (this.selection && !this.filteredConfigurations.includes(this.selection)) {
      // this.selection = null;
    }

    // If there is only one configuration select it by default
    if (this.filteredConfigurations.length === 1) {
      this.selection = this.filteredConfigurations[0];
    }

    this.paginator.length = this.filteredConfigurations.length;
  }

  /**
   * Changes the selection each time we click on a row
   *
   * @param row - the selected row
   */
  select(row): void {
    this.selection = row;
  }

  /**
   * Applies the selected configuration
   */
  executeRvt(): void {
    this.selectedId = this.selection.id;
    const selectedConfiguration = this.selection;
    this.executeRvtClick.emit(selectedConfiguration);
  }

  private defaultComparator(config1: Configuration, config2: Configuration): number {
    if (config1?.manifest?.dataGenerated && config2?.manifest?.dataGenerated) {
      return new Date(config2.manifest.dataGenerated).getTime() - new Date(config1.manifest.dataGenerated).getTime();
    }
    return 0;
  }
}
